export default __webpack_public_path__ + "static/media/card.351cd20d.svg";